/* Gallery videos stay lazy. Reduced motion prevents autoplay, not an explicit play. */
(function(){
  var root = document.querySelector('.lhero-media');
  if (!root) return;
  var main = root.querySelector('.lhero-img'), zoom = root.querySelector('.lhero-zoom');
  var thumbs = Array.from(root.querySelectorAll('.lhero-thumb'));
  var motion = matchMedia('(prefers-reduced-motion: reduce)');
  var videos = Array.from(root.querySelectorAll('.ga11y-video')).map(function(panel){
    var video = panel.querySelector('video'), button = panel.querySelector('button');
    return {panel:panel, video:video, button:button, visible:false, userPaused:false,
      loaded:false, wanted:false, pending:false, manualSession:false, request:0, sources:[], failedSources:new Set()};
  }).filter(function(state){ return state.video && state.button; });
  function label(state){
    state.button.hidden = false;
    state.button.textContent = state.wanted && (state.pending || !state.video.paused)
      ? state.button.dataset.pause : state.button.dataset.play;
    state.panel.setAttribute('aria-busy', String(state.pending));
  }
  function pause(state, byUser){
    state.request += 1;
    state.wanted = false;
    state.pending = false;
    state.manualSession = false;
    if (byUser) state.userPaused = true;
    state.video.pause();
    label(state);
  }
  function fail(state){
    pause(state, false);
    state.loaded = false;
    state.panel.dataset.videoError = 'true';
  }
  function load(state){
    if (state.loaded) return true;
    var video = state.video;
    state.failedSources.clear();
    state.sources = Array.from(video.querySelectorAll('source')).filter(function(source){
      if (!source.dataset.src || (source.type && !video.canPlayType(source.type))) return false;
      try {
        var url = new URL(source.dataset.src, location.href);
        if (url.protocol !== 'https:' && !(url.protocol === 'http:' && url.origin === location.origin)) return false;
        source.src = url.href;
        return true;
      } catch (_) { return false; }
    });
    if (!state.sources.length) return false;
    state.loaded = true;
    video.muted = true;
    video.playsInline = true;
    video.load();
    return true;
  }
  function play(state){
    if (state.wanted && (state.pending || !state.video.paused)) return;
    videos.forEach(function(other){ if (other !== state && (other.wanted || !other.video.paused)) pause(other, false); });
    if (!load(state)) { fail(state); return; }
    state.panel.removeAttribute('data-video-error');
    state.wanted = true;
    state.pending = true;
    state.video.muted = true;
    var request = ++state.request;
    label(state);
    var playing = state.video.play();
    if (playing && typeof playing.then === 'function') playing.then(function(){
      if (request !== state.request || !state.wanted) return;
      state.pending = false;
      label(state);
    }).catch(function(){
      if (request !== state.request) return;
      fail(state);
    });
  }
  // A hidden video still downloads its poster, so the poster waits until the panel is shown.
  function poster(state){
    var video = state.video;
    if (!video.getAttribute('poster') && video.dataset.poster) video.poster = video.dataset.poster;
  }
  function update(state, manual){
    label(state);
    if (state.panel.hidden || document.hidden) { pause(state, false); return; }
    poster(state);
    if (manual) {
      state.userPaused = false;
      state.manualSession = true;
      play(state);
      return;
    }
    if (!state.visible || state.userPaused) { pause(state, false); return; }
    if (motion.matches) {
      if (!state.manualSession || !state.wanted) pause(state, false);
      return;
    }
    play(state);
  }
  videos.forEach(function(state){
    var video = state.video;
    state.button.addEventListener('click', function(){
      if (state.wanted || !video.paused) pause(state, true);
      else update(state, true);
    });
    video.addEventListener('play', function(){
      if (!state.wanted || state.panel.hidden || document.hidden) { pause(state, false); return; }
      videos.forEach(function(other){ if (other !== state && (other.wanted || !other.video.paused)) pause(other, false); });
      label(state);
    });
    video.addEventListener('playing', function(){
      if (!state.wanted || state.panel.hidden || document.hidden) { pause(state, false); return; }
      state.pending = false;
      label(state);
    });
    video.addEventListener('pause', function(){ label(state); });
    video.addEventListener('error', function(){ if (state.loaded || state.wanted) fail(state); });
    video.querySelectorAll('source').forEach(function(source){
      source.addEventListener('error', function(){
        if (!state.loaded || !state.sources.includes(source)) return;
        state.failedSources.add(source);
        if (state.failedSources.size === state.sources.length) fail(state);
      });
    });
    label(state);
  });
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        var state = videos.find(function(item){ return item.panel === entry.target; });
        if (!state) return;
        state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.1;
        update(state);
      });
    }, {threshold:0.1});
    videos.forEach(function(state){ observer.observe(state.panel); });
  }
  function reset(){
    if (zoom) zoom.hidden = false;
    videos.forEach(function(state){ state.panel.hidden = true; pause(state, false); });
  }
  function selectThumb(thumb, manual){
    reset();
    if (thumb.dataset.video) {
      if (zoom) zoom.hidden = true;
      var state = videos.find(function(item){ return item.panel.dataset.mediaId === thumb.dataset.video; });
      if (state) { state.panel.hidden = false; update(state, manual); }
    } else if (main) {
      var thumbnail = thumb.querySelector('img');
      // The thumbnail img only carries thumbnail sizes; the button holds the photo-sized candidates.
      if (thumb.dataset.srcset) main.srcset = thumb.dataset.srcset;
      else if (thumbnail) main.srcset = thumbnail.srcset;
      main.src = thumb.dataset.src;
      main.alt = thumb.getAttribute('aria-label') || '';
      if (zoom) { zoom.dataset.full = thumb.dataset.src; zoom.setAttribute('aria-label', main.alt); }
    }
    thumbs.forEach(function(item){ item.setAttribute('aria-pressed', String(item === thumb)); });
  }
  thumbs.forEach(function(thumb){ thumb.addEventListener('click', function(){ selectThumb(thumb, true); }); });
  // Arrows and a swipe step through the photos the page shows (owner, 26 Oct 2026). Hidden thumbs
  // belong to another variant and are skipped; the last photo wraps to the first.
  function step(dir){
    var shown = thumbs.filter(function(thumb){ return !thumb.hidden; });
    if (shown.length < 2) return;
    var at = shown.findIndex(function(thumb){ return thumb.getAttribute('aria-pressed') === 'true'; });
    var next = shown[((at < 0 ? 0 : at) + dir + shown.length) % shown.length];
    selectThumb(next, true);
    if (next.scrollIntoView) next.scrollIntoView({block:'nearest', inline:'nearest'});
  }
  var arrows = [-1, 1].map(function(dir){
    var arrow = document.createElement('button');
    arrow.type = 'button';
    arrow.className = 'lhero-arrow lhero-arrow--' + (dir < 0 ? 'prev' : 'next');
    arrow.setAttribute('aria-label', (dir < 0 ? root.dataset.prev : root.dataset.next) || '');
    arrow.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="' + (dir < 0 ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '"/></svg>';
    arrow.addEventListener('click', function(){ step(dir); });
    root.appendChild(arrow);
    return arrow;
  });
  // The arrows sit at the middle of whatever is shown: the photo, or a video panel.
  function placeArrows(){
    var many = thumbs.filter(function(thumb){ return !thumb.hidden; }).length > 1;
    var stage = zoom && !zoom.hidden ? zoom : root.querySelector('.ga11y-video:not([hidden])');
    arrows.forEach(function(arrow){
      arrow.hidden = !many || !stage;
      if (arrow.hidden) return;
      // On the photo itself, inside its edges: never over the thumbs beside it.
      arrow.style.top = (stage.offsetTop + stage.offsetHeight / 2) + 'px';
      arrow.style.right = 'auto';
      arrow.style.left = (arrow.classList.contains('lhero-arrow--prev') ? stage.offsetLeft + 8 : stage.offsetLeft + stage.offsetWidth - arrow.offsetWidth - 8) + 'px';
    });
  }
  thumbs.forEach(function(thumb){ thumb.addEventListener('click', function(){ requestAnimationFrame(placeArrows); }); });
  document.addEventListener('grig:variant', function(){ requestAnimationFrame(placeArrows); });
  window.addEventListener('resize', placeArrows);
  if (main) main.addEventListener('load', placeArrows);
  placeArrows();
  // A horizontal swipe changes the photo; the tap that ends it does not open the zoom.
  var touch = null, swiped = false;
  root.addEventListener('touchstart', function(event){
    if (event.target.closest('.lhero-thumbs, .lhero-arrow') || event.touches.length !== 1) { touch = null; return; }
    touch = {x:event.touches[0].clientX, y:event.touches[0].clientY};
  }, {passive:true});
  root.addEventListener('touchend', function(event){
    if (!touch) return;
    var dx = event.changedTouches[0].clientX - touch.x, dy = event.changedTouches[0].clientY - touch.y;
    touch = null;
    if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
    swiped = true;
    setTimeout(function(){ swiped = false; }, 400);
    step(dx < 0 ? 1 : -1);
    requestAnimationFrame(placeArrows);
  });
  if (zoom) zoom.addEventListener('click', function(event){
    if (!swiped) return;
    swiped = false;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
  document.addEventListener('grig:variant', reset);
  document.addEventListener('visibilitychange', function(){ videos.forEach(function(state){ update(state); }); });
  motion.addEventListener('change', function(){ videos.forEach(function(state){ update(state); }); });
  if (!zoom) {
    var first = thumbs.find(function(thumb){ return !thumb.hidden; });
    if (first) selectThumb(first, false);
  }
  if (!zoom) return;
  var dialog = document.createElement('dialog');
  dialog.className = 'lhero-lb';
  dialog.hidden = true;
  dialog.setAttribute('aria-label', root.dataset.close);
  dialog.innerHTML = '<button type="button" class="lhero-lb-x">×</button><img alt="" width="900" height="900" decoding="async">';
  var close = dialog.querySelector('button'), image = dialog.querySelector('img');
  close.setAttribute('aria-label', root.dataset.close);
  document.body.appendChild(dialog);
  zoom.addEventListener('click', function(){
    image.srcset = main.srcset;
    image.sizes = '92vw';
    image.src = zoom.dataset.full;
    image.alt = main.alt;
    dialog.setAttribute('aria-label', main.alt || zoom.getAttribute('aria-label'));
    dialog.hidden = false;
    dialog.showModal();
    close.focus();
  });
  close.addEventListener('click', function(){ dialog.close(); });
  dialog.addEventListener('click', function(event){ if (event.target === dialog) dialog.close(); });
  // Focus goes back to the image the lightbox opened from, scrolled into view (below the sticky
  // header) should the page have moved meanwhile: the page under it is held still (grig-a11y.css),
  // but a script or a turned phone can still move it.
  dialog.addEventListener('close', function(){
    dialog.hidden = true;
    zoom.focus({preventScroll:true});
    if (document.activeElement === zoom) zoom.scrollIntoView({block:'nearest', inline:'nearest'});
  });
})();
